import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default class ChannelObject extends BaseChannelSerializer {}